import React from 'react';
import { Link, useHistory } from 'react-router-dom';

type BitLinkButtonProps = {
	link?: string;
	text: string;
	textColor?: string;
	buttonColor?: string;
	external?: boolean;
	useGoBack?: boolean;
	onClick?: (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => void;
};

const BitLinkButton: React.FC<BitLinkButtonProps> = ({
	link,
	text,
	textColor,
	buttonColor,
	external,
	useGoBack,
	onClick,
}) => {
	const history = useHistory();

	const defaultLink = '/';
	const defaultText = 'Seu texto';
	const defaultTextColor = 'rgba(255, 255, 255, var(--text-opacity))';
	const defaultButtonColor = '#91b820';

	const textString = (text || '').toString().trim().toUpperCase();
	const isVoltar =
		useGoBack || textString.startsWith('VOLTAR') || textString.includes('VOLTAR');

	const handleClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
		if (onClick) {
			onClick(e);
		}

		if (external) {
			return;
		}

		if (isVoltar) {
			e.preventDefault();
			if (window.history.length > 1) {
				history.goBack();
			} else if (link) {
				history.push(link);
			} else {
				history.push(defaultLink);
			}
		}
	};

	if (external) {
		return (
			<a
				className="button button--outlined"
				style={{
					color: textColor ?? defaultTextColor,
					backgroundColor: buttonColor ?? defaultButtonColor,
				}}
				href={link ?? defaultLink}
				onClick={onClick}
			>
				{text ?? defaultText}
			</a>
		);
	}

	return (
		<Link
			className="button button--outlined"
			style={{
				color: textColor ?? defaultTextColor,
				backgroundColor: buttonColor ?? defaultButtonColor,
			}}
			to={link ?? defaultLink}
			onClick={handleClick}
		>
			{text ?? defaultText}
		</Link>
	);
};

export default BitLinkButton;
